import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import {
  InputWithPlaceHolder, HeaderLabel, CellText, TypeSelector, ModuleSelector,
} from '../../../components/report-components'
import {
  RolesSelector,
} from '../../../components/user-components'

export default {
  columns: [{
    Header: () => <HeaderLabel>id</HeaderLabel>,
    accessor: 'id',
    Cell: props => <CellText textAlign='right'>{props.value}</CellText>,
    sortable: false,
    width: 90,
  }, {
    Header: () => <HeaderLabel>ชื่อโมดูล</HeaderLabel>,
    accessor: 'moduleName',
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <ModuleSelector handleChange={e => onChange(e)} statusAttr='ทั้งหมด' filter={true}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: false,
    filterable: true,
    width: 150,
  }, {
    Header: () => <HeaderLabel>รายงาน</HeaderLabel>,
    accessor: 'message',
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText>{props.value}</CellText>
      </Tooltip>
    ),
    sortable: false,
    width: 500,
  }, {
    Header: <HeaderLabel>ชื่อผู้ใช้</HeaderLabel>,
    accessor: 'actor.fullname',
    sortable: false,
    filterable: true,
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText>{props.value}</CellText>
      </Tooltip>
    ),
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 180,
  }, {
    Header: <HeaderLabel>หน้าที่</HeaderLabel>,
    accessor: 'actor.Roles',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value[0].description}</CellText>,
    Filter: ({ onChange }) => <RolesSelector handleChange={e => onChange(e)} statusAttr='ทั้งหมด' filter={true}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 160,
  }, {
    Header: <HeaderLabel>ประเภท</HeaderLabel>,
    accessor: 'type',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <TypeSelector handleChange={e => onChange(e)} statusAttr='ทั้งหมด' filter={true}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 120,
  }, {
    Header: <HeaderLabel>Ref ID</HeaderLabel>,
    accessor: 'refId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.refId, filter.value),
    width: 120,
  }, {
    Header: <HeaderLabel>Created At</HeaderLabel>,
    accessor: 'createdAt',
    sortable: false,
    Cell: props => <CellText textAlign='center'>{moment(props.value).format('YYYY-MM-DD HH:mm:ss')}</CellText>,
    width: 200,
  }],
}
